/* Présentation produit — pop-up (image / PDF / vidéo) */
(function () {
  function toEmbedUrl(url) {
    if (!url) return '';
    // YouTube
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    // Vimeo
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    // Fallback : lien direct (mp4, etc.)
    return url;
  }

  function buildContent(type, src, title) {
    if (type === 'video') {
      var embed = toEmbedUrl(src);
      if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(src)) {
        return '<video class="shp__modal-video" src="' + src + '" controls autoplay playsinline style="width:100%;height:auto;display:block"></video>';
      }
      return '<div class="shp__embed"><iframe src="' + embed + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="' + (title || '') + '"></iframe></div>';
    }
    if (type === 'pdf') {
      return '<iframe class="shp__pdf" src="' + src + '" title="' + (title || '') + '"></iframe>';
    }
    return '<img class="shp__modal-img" src="' + src + '" alt="' + (title || '') + '">';
  }

  function init(root) {
    if (!root || root.__shpInit) return;
    root.__shpInit = true;

    var modal = root.querySelector('[data-shp-modal]');
    var content = root.querySelector('[data-shp-modal-content]');
    if (!modal || !content) return;

    function open(html) {
      content.innerHTML = html;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      content.innerHTML = ''; // stoppe la lecture des vidéos
      document.documentElement.style.overflow = '';
    }

    root.querySelectorAll('[data-shp-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(buildContent(
          btn.getAttribute('data-shp-type'),
          btn.getAttribute('data-shp-src'),
          btn.getAttribute('data-shp-title')
        ));
      });
    });

    modal.querySelectorAll('[data-shp-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-shp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
